module.exports = __webpack_public_path__ + "static/media/gray_scale_with_water.28a7b813.jpg";